import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { getTotalTop100Balance, CIRCULATING_SUPPLY } from '../data/wallets';
export function DistributionChart() {
  const top100Balance = getTotalTop100Balance();
  const remainingBalance = CIRCULATING_SUPPLY - top100Balance;
  const data = [{
    name: 'Top 100 Wallets',
    value: top100Balance,
    color: '#F97316'
  }, {
    name: 'All Other Wallets',
    value: remainingBalance,
    color: '#6B7280'
  }];
  const COLORS = ['#F97316', '#6B7280'];
  return <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-15">
      <h3 className="text-white text-xl font-bold mb-6" data-id="element-16">
        Bitcoin Distribution
      </h3>
      <ResponsiveContainer width="100%" height={300} data-id="element-17">
        <PieChart data-id="element-18">
          <Pie data={data} cx="50%" cy="50%" labelLine={false} label={({
          name,
          percent
        }) => `${name}: ${(percent * 100).toFixed(1)}%`} outerRadius={100} fill="#8884d8" dataKey="value" data-id="element-19">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-20" />)}
          </Pie>
          <Tooltip contentStyle={{
          backgroundColor: '#1F2937',
          border: '1px solid #374151',
          borderRadius: '8px',
          color: '#fff'
        }} formatter={(value: number) => [`${value.toLocaleString()} BTC (${(value / CIRCULATING_SUPPLY * 100).toFixed(2)}%)`, 'Balance']} data-id="element-21" />
          <Legend wrapperStyle={{
          color: '#9CA3AF'
        }} iconType="circle" data-id="element-22" />
        </PieChart>
      </ResponsiveContainer>
      <div className="mt-6 grid grid-cols-2 gap-4" data-id="element-23">
        <div className="bg-gray-900/50 rounded-lg p-4" data-id="element-24">
          <p className="text-gray-400 text-sm mb-1" data-id="element-25">Top 100 Total</p>
          <p className="text-white text-xl font-bold font-mono" data-id="element-26">
            {top100Balance.toLocaleString()} BTC
          </p>
        </div>
        <div className="bg-gray-900/50 rounded-lg p-4" data-id="element-27">
          <p className="text-gray-400 text-sm mb-1" data-id="element-28">Concentration</p>
          <p className="text-orange-500 text-xl font-bold font-mono" data-id="element-29">
            {(top100Balance / CIRCULATING_SUPPLY * 100).toFixed(2)}%
          </p>
        </div>
      </div>
    </div>;
}